import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MainActionCreators } from '../../state/reducer';
import * as store from '../../state/store';

const useBlurOk = (): boolean => {
  return useSelector<store.IAppState, boolean>(state => state.appearance.blurOk);
};

export const useBlurCapabilityChecker = () => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(MainActionCreators.setBlurOk(checkBlurCapability()));
  }, []);
};

function checkBlurCapability(): boolean {
  // Strategy 1: Check user preferences
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return false;
  }

  // Strategy 2: Check device capabilities
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  const hasLowMemory = (navigator as any).deviceMemory && (navigator as any).deviceMemory < 4;
  const hasLowCores = (navigator.hardwareConcurrency || 1) <= 2;

  if (isMobile || hasLowMemory || hasLowCores) {
    return false;
  }

  // Strategy 3: Check CSS support
  return CSS.supports('backdrop-filter', 'blur(1px)');
}

export default useBlurOk;
